// Laço linear: /\/+$/ é quadrático em strings com muitas barras seguidas de
// um caractere e uma barra final (ReDoS no event loop do SSR).
export function trimTrailingSlashes(value: string): string {
	let end = value.length;

	while (end > 0 && value.charCodeAt(end - 1) === 47) end--;

	return value.slice(0, end);
}
